import { render, staticRenderFns } from "./ResultLoadMoreButton.vue?vue&type=template&id=85cedf82&scoped=true&"
import script from "./ResultLoadMoreButton.vue?vue&type=script&lang=js&"
export * from "./ResultLoadMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./ResultLoadMoreButton.vue?vue&type=style&index=0&id=85cedf82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cedf82",
  null
  
)

component.options.__file = "ResultLoadMoreButton.vue"
export default component.exports